export enum TemplateTheme {
  DEFAULT = 1,
  DARK = 2,
  LIGHT = 3,
  BLUE = 4
}

export enum TemplateSize {
  RESPONSIVE = 1,
  SMALL = 2,
  MEDIUM = 3
}
